import './MainCategoryHeader.scss';
import images from '../../assets/images';
import { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getScreenDimensions } from '../../utils/helper';
import MobileHeader from '../MobileHeader/MobileHeader';
import { useAppSelector } from '../../redux/app/hooks';
import { useLazyQuery } from '@apollo/client';
import { GET_CLASSROOM_BY_ID } from '../../pages/AdminClassroom/api/AdminClassroomQuery';
import { ClassroomByIdDetailsType } from '../../pages/AdminClassroom/AdminClassroom';
import { FETCH_POLICY_NO_CACHE, MYLIBRARY_TEXTS, SCHOOL_ADMIN } from '../../utils/constants';

interface PropsType{
    navigateLocation: string;
}
const MainCategoryHeader:FC<PropsType> = ({navigateLocation}) => {
    const {exitIcon, bookIcon} = images;
    const navigate = useNavigate();
    const location = useLocation();
    const role = useAppSelector((state) => state.auth.role);  

    const categoryName = () => {
        if(location.pathname.includes('ebooks')){
            return 'E-Books';
        }else if(location.pathname.includes('images')){
            return MYLIBRARY_TEXTS?.IMAGES_TEXT;
        }else if(location.pathname.includes('podcast')){
            return MYLIBRARY_TEXTS?.PODCAST_TEXT;
        }else if(location.pathname.includes('videos')){
            return MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT;
        }
      }

      const [classroomByIdDetails, setClassroomByIdDetails] =
          useState<ClassroomByIdDetailsType>();
        const selectedClassroomId = useAppSelector(
          (state) => state.CommonUpload.classroomId
        );
      
        const [getClassroomById, { loading }] = useLazyQuery(GET_CLASSROOM_BY_ID, {
          fetchPolicy: FETCH_POLICY_NO_CACHE,
          onCompleted: (data) => {
            setClassroomByIdDetails(data?.classroomByCId);
          },
        });

        useEffect(() => {
            if(role === SCHOOL_ADMIN) {
              getClassroomById({
                variables: {
                  cId: selectedClassroomId,
                },
              });
            }
          }, [selectedClassroomId]);

  return (
    <div className='outermainCategoryHeaderContainer'>
    <div className='mainCategoryHeaderContainer'>
        <div className='backIconContainer' onClick={() => {navigate(navigateLocation)}}>
            <img src={exitIcon} alt='backIcon' className='backIcon'/>
        </div>

        {classroomByIdDetails && <div className="header-div">
                <div className="imageContainer">
                  <img src={bookIcon} alt="userImage" className="imageStyle" />
                </div>
                <div className="header-title-div">
                  <div className="primary">Upload</div>
                  <div className="secondary">
                    {`${classroomByIdDetails?.cOriginalName} - ${categoryName()}`}
                  </div>
                </div>
              </div>}
              
       { (!classroomByIdDetails && !loading) && <div className='categoryName'>
             {categoryName()}
        </div>}

         
    </div>
    {getScreenDimensions()?.isMobileScreen && <MobileHeader />}
    </div>
  )
}

export default MainCategoryHeader;
